var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-action-btn',{attrs:{"disabled":_vm.pending,"loading":_vm.pending,"tooltip":_vm.$t('common.download'),"icon":"file_download"},on:{"click":_vm.download}})
}
var staticRenderFns = []

export { render, staticRenderFns }